export default "__VITE_ASSET__C0Hb6aS5__"